var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-layout"},[_c('div',{staticClass:"details-layout__title"},[_vm._t("header")],2),_c('div',{staticClass:"details-layout__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }